import api from '../../../../api/clients/api';
import { Destination } from '../types/destination';
import { CreateDestinationPayload } from '../types/payload/create-destination.payload';
import { UpdateDestinationPayload } from '../types/payload/update-destination.payload';

import { AccessControlProfile } from '@/features/access-control-profiles/api/types/access-control-profile';
import { PaginatedResponse } from '@/types/responses/paginated-response';

class DestinationsApi {
  async fetchDestinations(
    page: number,
    perPage: number,
    search?: string,
  ): Promise<PaginatedResponse<Destination>> {
    const { data } = await api.get<PaginatedResponse<Destination>>(`/destinations`, {
      params: { page, perPage, search },
    });

    return data;
  }

  async fetchDestination(destinationId: number): Promise<Destination> {
    const { data } = await api.get<Destination>(`/destinations/${destinationId}`);

    return data;
  }

  async updateDestination(
    destinationId: number,
    payload: UpdateDestinationPayload,
  ): Promise<Destination> {
    const { data } = await api.patch<Destination>(`/destinations/${destinationId}`, payload);

    return data;
  }

  async createDestination(payload: CreateDestinationPayload): Promise<Destination> {
    const { data } = await api.post<Destination>(`/destinations`, payload);

    return data;
  }

  async deleteDestination(destinationId: number): Promise<Destination> {
    const { data } = await api.delete<Destination>(`/destinations/${destinationId}`);

    return data;
  }

  async fetchAccessControlProfiles(): Promise<AccessControlProfile[]> {
    const { data } = await api.get<AccessControlProfile[]>(`/access-control-profiles`);

    return data;
  }

  //!! sprawdzić czy jest uaktualnione powinno pozwolic pryzpisac i ususnac wiele
  async updateDestinationAccessControlProfiles(
    destinationId: number,
    accessControlProfileIds: number[],
  ): Promise<void> {
    await api.put(`/destinations/${destinationId}/access-control-profiles`, {
      accessControlProfileIds,
    });
  }

  async unassignSingleAccessControlProfilesFromDestination(
    destinationId: number,
    accessControlProfileId: number,
  ): Promise<void> {
    await api.delete(
      `/destinations/${destinationId}/access-control-profiles/${accessControlProfileId}`,
    );
  }
}

export const destinationsApi = new DestinationsApi();
